<template>
	<div class="messagereply">
		<div class="usercontexttop">
			<div>我的留言与回复</div>
			<div class="btnpage" v-if="pages>1">
				<a href="javascript:void(0);" class="pagebtn1 mr" @click="sy">首页</a>
				<a href="javascript:void(0);" class="pagebtn1 mr" @click="syy">上一页</a>
				<a href="javascript:void(0);" class="pagebtn2 lebtn2" v-if="pageslist!=null" v-for="i in pageslist" :data-id="i" @click="selectpage(i)">{{i}}</a>
				<a href="javascript:void(0);" class="pagebtn1 ml" @click="xyy">下一页</a>
				<a href="javascript:void(0);" class="pagebtn1 ml" @click="wy">尾页</a>
			</div>
		</div>
		<div class="border">
			<div class="itemall" v-if="list.length===0">
				<div class="ttttttt">当前没有留言信息哦~</div>
			</div>
			<div class="messagereplyitem" v-for="item in list" :key="item.id">
				<div class="leftttttt">
					<div class="itemtop1">
						<div>
							<img src="../../assets/images/usersj.png" />
							<p>{{gettime(item.message_time)}}</p>
						</div>
						<div v-if="parseInt(item.is_look)===1">
							<img src="../../assets/images/send2.png" />
							<p><span>已查看</span></p>
						</div>
						<div v-else>
							<img src="../../assets/images/send1.png" />
							<p><span>未查看</span></p>
						</div>
					</div>
					<div class="itemtop2">
						<div class="itemtop2_left">
							<img src="../../assets/images/send1.png" />
							<p>{{item.message_content}}</p>
						</div>
						
					</div>
				</div>
				<div class="rightttttt">
					<div class="itemtop2_right">
						<div>
							<a href="javascript:void(0);" @click="showmessage(item.messageId,item.is_look)"><span>查看回复</span></a>
							<a href="javascript:void(0);" @click="insssss(item.cmsKnowledgePoints.id)"><span>查看原文</span></a>
						</div>
					</div>
				</div>
				<div class="umes" :data-id="item.messageId">
					<div class="messlist" v-if="item.list.length>0" v-for="ii in item.list">
						{{ii.name}}:&ensp;&ensp;<span>{{ii.message_content}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="btnpage2" v-if="pages>1">
		<a href="javascript:void(0);" class="pagebtn11" @click="sy"><span>首页</span></a>
		<a href="javascript:void(0);" class="pagebtn11" @click="syy"><span>上一页</span></a>
		<a href="javascript:void(0);" class="pagebtn22 lebtn" v-if="pageslist!=null" v-for="i in pageslist" :data-id="i" @click="selectpage(i)"><span>{{i}}</span></a>
		<a href="javascript:void(0);" class="pagebtn11" @click="xyy"><span>下一页</span></a>
		<a href="javascript:void(0);" class="pagebtn11" @click="wy"><span>尾页</span></a>
	</div>
</template>

<script>
	import axios from "axios"
	export default {
		name: 'messagereply',
		data(){
			return{
				token: this.$store.state.token, //token
				userid: this.$store.state.userid, //id
				list: [],
				pageNum: 1,
				pageSize: 20,
				pages: 0,//总页数
				pageslist: null,//只显示五页
			}
		},
		created() {
			this.getlist()
		},
		methods:{
			showmessage(id,type){
				if(parseInt(type)===0){
					axios({
							url: this.$api.commonUrl + "message/look/"+id,
							method: "GET",
							headers: {
								Authorization: "Bearer " + this.token,
							}
						}).then((res) => {
							if (res.data.code == "200") {
								this.getlist()
								let allmessage = document.getElementsByClassName('umes')
								for(let i =0;i<allmessage.length;i++){
									if(id===parseInt(allmessage[i].getAttribute('data-id'))&allmessage[i].className!='umes showm'){
										allmessage[i].className = 'umes showm'
									}else{
										allmessage[i].className = 'umes'
									}
								}
							}
						}).catch((err) => {
							console.log(err);
						})
				}else{
					let allmessage = document.getElementsByClassName('umes')
					for(let i =0;i<allmessage.length;i++){
						if(id===parseInt(allmessage[i].getAttribute('data-id'))&allmessage[i].className!='umes showm'){
							allmessage[i].className = 'umes showm'
						}else{
							allmessage[i].className = 'umes'
						}
					}
				}
			},
			getlist(){
				new Promise((resolve, reject)=>{
					axios({
						url: this.$api.commonUrl + "message/list",
						method: "GET",
						params:{
							status: '1',
							userId: this.userid,
							pageSize: this.pageSize,
							pageNum: this.pageNum
						},
						headers: {
							Authorization: "Bearer " + this.token,
						}
					}).then((res) => {
						if (res.data.code == "200") {
							this.list = res.data.data.list
							this.pages = res.data.data.pages
							if(parseInt(res.data.data.pages)>=5){
								for(let i = 1;i<=5;i++){
									if(this.pageNum>2){
										this.pageslist = [this.pageNum-2,this.pageNum-1,this.pageNum,this.pageNum+1,this.pageNum+2]
									}
									if(this.pageNum<=2){
										this.pageslist = [1,2,3,4,5]
									}
									if(this.pageNum>=this.pages-2){
										this.pageslist = [this.pages-4,this.pages-3,this.pages-2,this.pages-1,this.pages]
									}
								}
							}else if(parseInt(res.data.data.pages)<5){
								let newlist = []
								for(let i = 1;i<=parseInt(res.data.data.pages);i++){
									newlist.push(i)
								}
								this.pageslist = newlist
							}
							resolve()
						}
					}).catch((err) => {
						console.log(err);
					});
				}).then((res)=>{
					this.pushclass()
				})
				
			},
			insssss(id){
				this.$router.push({
					path: '/knowledgebasedetails',
					query:{
						id: id
					}
				})
			},
			gettime() {
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth() + 1;
				let dd = new Date().getDate();
				let hh = new Date().getHours();
				let mf =
					new Date().getMinutes() < 10 ?
					"0" + new Date().getMinutes() :
					new Date().getMinutes();
				let ss =
					new Date().getSeconds() < 10 ?
					"0" + new Date().getSeconds() :
					new Date().getSeconds();
				return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			},
			selectpage(i){
				this.pageNum = i
				this.getlist()
			},
			pushclass(){
				let allpageelement = document.getElementsByClassName('lebtn')
				let allpageelement2 = document.getElementsByClassName('lebtn2')
				for(let i =0;i<allpageelement.length;i++){
					if(parseInt(allpageelement[i].getAttribute('data-id'))===this.pageNum){
						allpageelement[i].className = 'pagebtn22 lebtn pageselect'
						allpageelement2[i].setAttribute("style", "color: #FFFFFF;")
					}else{
						allpageelement[i].className = 'pagebtn22 lebtn'
						allpageelement2[i].setAttribute("style", "color:#d49f79;")
					}
				}
			},
			sy(){
				if(this.pageNum!=1){
					this.pageNum = 1
					this.getlist()
				}
			},
			syy(){
				if(this.pageNum>1){
					this.pageNum -= 1
					this.getlist()
				}
			},
			xyy(){
				if(this.pageNum < this.pages){
					this.pageNum += 1
					this.getlist()
				}
			},
			wy(){
				if(this.pageNum != this.pages){
					this.pageNum = this.pages
					this.getlist()
				}
			},
		}
	}
</script>

<style scoped>
	.messagereply {
		background: #FFFFFF;
		border: 1px solid #a2693f;
	}
	.messagereply .messlist{
		background: #ac8461;
		    margin: -1rem;
		    margin-top: 0.5rem;
		    padding: 0.5rem;
		    color: #FFFFFF;
				font-size: 0.9rem;
	}
	.messagereply .border {
		border: 1px solid #a2693f;
		margin: 1px;
	}

	.messagereply .messagereplyitem {
		padding: 1rem;
		border-bottom: 1px dashed #dbb48a;
		position: relative;
	}

	.messagereply .messagereplyitem:last-child {
		border: none;
	}

	.messagereply .messagereplyitem:nth-child(even) {
		background: #faf7f3;
	}

	.messagereply .itemtop1 {
		height: 2rem;
	}

	.messagereply .itemtop1 div {
		width: 30%;
		height: 2rem;
		float: left;
	}

	.messagereply .itemtop1 div img {
		width: 1.3rem;
		height: 1.3rem;
		display: block;
		float: left;
		margin-top: 0.35rem;
	}

	.messagereply .itemtop1 div p {
		width: calc(100% - 3.5rem);
		height: 2rem;
		display: block;
		float: left;
		margin-left: 0.5rem;
		line-height: 2rem;
		font-size: 1.142857rem;
		color: #896247;
		padding-left: 0.7rem;

	}

	.messagereply .itemtop1 div p span {
		color: #a73a29;
	}

	.messagereply .itemtop2 {
		width: 100%;
	}

	.messagereply .itemtop2 .itemtop2_left {
	}

	.messagereply .itemtop2 .itemtop2_right {
	}

	.messagereply .itemtop2 .itemtop2_left img {
		width: 1.3rem;
		height: 1.3rem;
		display: block;
		float: left;
		margin-top: 0.35rem;
	}

	.messagereply .itemtop2 .itemtop2_left p {
		height: auto;
		line-height: 2rem;
		padding-left: 2.5rem;
		color: #7d7774;
		font-size: 1.142857rem;
	}

	.messagereply .itemtop2_right div {
		height: 2rem;
		width: 100%;
		text-align: center;
	}

	.messagereply .itemtop2_right div a {
		text-decoration: none;
		color: #FFFFFF;
		display: inline-block;
		width: 8rem;
		height: 2rem;
		line-height: calc(2rem - 4px);
		position: relative;
		font-size: 0.9rem;
	}

	.messagereply .itemtop2_right div a:first-child {
		background: #a73a29;
		margin-right: 1rem;
	}

	.messagereply .itemtop2_right div a:last-child {
		background: #cea57d;
		margin-left: 1rem;
	}

	.messagereply .itemtop2_right div a:first-child span {
		background: #a73a29;
		border: 1px solid #FFFFFF;
		position: absolute;
		top: 1px;
		left: 1px;
		right: 1px;
		bottom: 1px;
	}

	.messagereply .itemtop2_right div a:last-child span {
		background: #cea57d;
		border: 1px solid #FFFFFF;
		position: absolute;
		top: 1px;
		left: 1px;
		right: 1px;
		bottom: 1px;
	}
	.messagereply .umes{
		display: none;
	}
	.messagereply .showm{
		display: block !important;
	}
	.messagereplyitem .leftttttt{
		width: calc(100% - 20rem);
		
	}
	.messagereplyitem .rightttttt{
		width: 20rem;
		height: 2rem;
		float: right;
		position: absolute;
		margin: auto;
		right: 0;
		top: 0;
		bottom: 0;
	}
	.itemall {
		background: #f7e9d3;
		height: auto;
		position: relative;
		min-height: 8rem;
	}
	.ttttttt{
		line-height: 760px;
		height: 760px;
		text-align: center;
		width: 100%;
		color: #d49f79;
		font-size: 1.285714rem;
	}
</style>
